import React from "react";
import { toElementProps } from "../../Element";
import Carousel, { CarouselStyles } from "./Carousel.jsx";
import Block, { BlockStyles } from "../technical/Block.jsx";

export function BlockSliderStyles(params = {}) {
    const { palette, MobileBreakpoint } = params;

    return {
        "& .block-slider": {
            display: "grid",

            "& .slider-content": {
                justifyContent: "center",
                justifySelf: "center",
                maxWidth: "1200px",

                [MobileBreakpoint]: {
                    padding: 0,
                },
            },
        },

        ...BlockStyles(params),
        ...CarouselStyles(params),
    };
}

export default function BlockSlider(props) {
    const { Slider } = props.variables;

    if (!Slider) {
        return null;
    }

    const _Slider = Slider?.filter(item => item.image);

    if (_Slider.length === 0) {
        return null;
    }

    const CNSlider = ["block-slider"];
    const elProps = toElementProps(props, { className: CNSlider });

    return (
        <Block>
            <div {...elProps}>
                <div className="slider-content">
                    <Carousel items={_Slider} />
                </div>
            </div>
        </Block>
    );
}
